import type { FC } from 'react';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { SYS_SPACE_FIXED_200 } from '@oneaudi/unified-web-common';
import { FAStateContext } from '../context/FAStateContext';
import { CarName } from './CarName';
import { PriceText } from './PriceText';
import { ConfigureButton } from './ConfigureButton';

const CarlineOptionWrapper = styled.div`
  display: block;
  @media (min-width: ${(props) => props.theme.breakpoints.xl}px) {
    display: flex;
    justify-content: space-between;
  }
`;
const ConfigureButtonWrapper = styled.div<{ show: boolean }>`
  display: block;
  margin-top: ${SYS_SPACE_FIXED_200};
  @media (min-width: ${(props) => props.theme.breakpoints.xl}px) {
    display: ${({ show }) => (show ? `flex` : `none`)};
    justify-content: space-between;
    margin-top: 0;
  }
`;
export const CarlineOption: FC = () => {
  const { viewMode } = useContext(FAStateContext);
  return (
    <CarlineOptionWrapper>
      <div>
        <CarName />
        <PriceText />
      </div>
      <ConfigureButtonWrapper show={viewMode === '3dStream'}>
        <ConfigureButton />
      </ConfigureButtonWrapper>
    </CarlineOptionWrapper>
  );
};
